import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Strict email regex kept in sync with the backend's `@IsEmail()`
 * (validator.js), which is what actually decides whether a save succeeds.
 *
 * Angular's built-in `Validators.email` treats the TLD as optional and accepts
 * single-label domains like `foo@bar`. A looser "any dot will do" pattern also
 * let through `user@gmail.com5193` and `user@hotmail..com`, which the backend
 * rejects with a 400 the customer can only read as "Failed to update". Each
 * domain label must be alphanumeric with optional inner hyphens, and the TLD
 * must be at least two letters.
 */
export const EMAIL_REGEX =
  /^[^\s@]+@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;

/**
 * Drop-in replacement for Angular's `Validators.email`.
 *
 * Returns the same `{ email: true }` error key, so existing formly message
 * mappings keep working. Empty values pass (use `Validators.required` for that).
 */
export const emailValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;

  if (value === null || value === undefined || value === '') {
    return null;
  }

  return EMAIL_REGEX.test(value) ? null : { email: true };
};
